/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(document).ready(function() {
  var $slider = $(".Product__SlideshowNav.Product__SlideshowNav--thumbnails .Product__SlideshowNavScroller");
  var flkty = Flickity.data(document.querySelector('.Product__Slideshow'));

  var syncing = false;

  $slider.on('afterChange', function(event, slick, currentSlide){
    if(syncing) return;
    syncing = true;

    // Sync Flickity to Slick's current slide
    flkty.select(currentSlide);

    syncing = false;
  });

  // flkty.on('select', function() {
  //   if(syncing) return;
  //   syncing = true;

  //   // Sync Slick to Flickity's current slide
  //   $slider.slick('slickGoTo', flkty.selectedIndex);

  //   syncing = false;
  // });
  $('.flickity-prev-next-button.previous').click(function(){
    $('.Product__SlideshowNavArrow--previous.slick-arrow').click();
})
$('.flickity-prev-next-button.next').click(function(){
    $('.Product__SlideshowNavArrow--next.slick-arrow').click();
})
});
document.addEventListener('DOMContentLoaded', function () {
  const flickity = new Flickity('.Product__Slideshow', {
    prevNextButtons: true,
    pageDots: false,
    adaptiveHeight: true,
    watchCSS: true,
    dragThreshold: 8,
    initialIndex: 0 
  });


  const prevButton = document.querySelector('.flickity-prev-next-button.previous');
  const nextButton = document.querySelector('.flickity-prev-next-button.next');
  if (prevButton) {
    prevButton.innerHTML = `
      <svg role="presentation" viewBox="0 0 6 9">
        <path d="M5 8.5l-4-4 4-4" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>
      </svg>
    `;
  }
  if (nextButton) {
    nextButton.innerHTML = `
      <svg role="presentation" viewBox="0 0 6 9">
        <path d="M1 8.5l4-4-4-4" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>
      </svg>
    `;
  }
})
jQuery(document).ready(function($) {
  $('button.Collapsible__Button.Heading.u-h6.custom_product_tabs').trigger('click');
  $('.Container.new-Brands-Logos').slick({
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
     pauseOnHover:false,
    cssEase: 'linear',
    slidesToShow: 6,
    slidesToScroll: 1,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false,
    responsive: [
      {
        breakpoint: 901,
        settings: {
          slidesToShow: 5,            
        },
      },
      {
        breakpoint: 501,
        settings: {
          slidesToShow: 3,            
        },
      },


    ],
  });



if(window.innerWidth >= 768){

$(".Product__SlideshowNav.Product__SlideshowNav--thumbnails .Product__SlideshowNavScroller").slick({
        verticalSwiping: true,
        
        vertical: true,
    draggable: true,
      infinite: true,
       focusOnSelect: true,  
      slidesToShow: 6,
      slidesToScroll: 1,
      prevArrow:"<button class='product-page-desktop Product__SlideshowNavArrow Product__SlideshowNavArrow--previous' type='button' data-direction='previous' aria-label='Previous'><svg class='Icon Icon--media-arrow-left' role='presentation' viewBox='0 0 6 9'><path d='M5 8.5l-4-4 4-4' stroke='currentColor' fill='none' fill-rule='evenodd' stroke-linecap='square'></path></svg></button>",
      nextArrow:"<button class='product-page-desktop Product__SlideshowNavArrow Product__SlideshowNavArrow--next' type='button' data-direction='next' aria-label='Next'><svg class='Icon Icon--media-arrow-right' role='presentation' viewBox='0 0 6 9'><path d='M1 8.5l4-4-4-4' stroke='currentColor' fill='none' fill-rule='evenodd' stroke-linecap='square'></path></svg></button>",
      dots: false 
    });
  }
if (window.innerWidth < 768) {
  const flkty = new Flickity('.Product__SlideshowNav.Product__SlideshowNav--thumbnails .Product__SlideshowNavScroller', {
    pageDots: false,
    prevNextButtons: false,
    draggable: true,
    wrapAround: true,
    cellAlign: 'left',       // Align slides to left
    contain: true  ,
    asNavFor: '.Product__Slideshow',
    arrowShape: {
      x0: 10,
      x1: 60, y1: 50,
      x2: 70, y2: 40,
      x3: 30
    },
    axis: 'x',
    initialIndex: 0 
  });

  let isDragging = false;

  flkty.on('dragStart', function () {
    isDragging = true;
  });

  flkty.on('select', function () {
  
    flkty.cells.forEach(cell => {
      cell.element.classList.remove('is-selected');
    });

    if (!isDragging) {
      flkty.selectedElement.classList.add('is-selected');
    }
  });

  flkty.on('dragEnd', function () {
    isDragging = false;
  });

  flkty.selectedElement.classList.add('is-selected');
}


});
function myFunction() {
  var element = document.getElementById("myDIV");
  element.style.display = "none";
}  
      
//       Custom js for tag tree
      $("#BlogTagFilter").change(function(){
      var url=$("#BlogTagFilter option:selected").val();
      window.location.href= url;
      });
      
      
      $("button.product_page_fm_btn").click(function(){
$(".main_ask_a_question_overlay").show();

});
